module.exports = __webpack_public_path__ + "img/posterBg2-1.3ca8dc2b.png";